// Reads the /hitpay/payment_request response into what the QR popup needs.
// The API may return the QR as an image/data URL, or only a hosted checkout URL.
export const readHitPayResponse = (result) => {
  const data = result?.data?.payment_request || result?.data || result || {};
  const raw = data.qr_code_data?.qr_code || data.qr_code || data.qr_image || data.qr || "";
  const isImageSource = /^data:image/.test(raw) || /^https?:.*\.(png|jpe?g|svg|gif)(\?|$)/i.test(raw);
  const isBase64Image = /^(iVBOR|\/9j\/)[A-Za-z0-9+/=]+$/.test(raw);
  const qrImage = isImageSource ? raw : isBase64Image ? `data:image/png;base64,${raw}` : "";
  //ANYTHING ELSE IS THE PAYNOW PAYLOAD STRING, THE POPUP DRAWS THE QR FROM IT
  const qrText = raw && !qrImage ? raw : "";
  const url = data.url || data.redirect_url || data.checkout_url || "";
  const referenceNumber = data.reference_number || result?.reference_number || "";
  //THE BACKEND WEBHOOK LOOKS THE SAVED CART UP BY ITS OWN ORDER ID ("ORDER-YYYYMMDD-..."), NOT THE HITPAY reference_number
  const merchantOrderId = data.order_id || data.merchant_order_id || result?.order_id || result?.merchant_order_id || "";
  const orderId = referenceNumber || merchantOrderId || data.id || "";

  if (!qrImage && !qrText && !url) {
    return {
      ok: false,
      message: result?.message || result?.msg || result?.errorMessage || "HitPay payment request failed",
    };
  }
  return { ok: true, qrImage, qrText, url, orderId, merchantOrderId, referenceNumber, amount: data.amount };
};
